__turbopack_context__.v({
  "search_landing__content": "wj3UPW_search_landing__content",
  "search_landing__filters": "wj3UPW_search_landing__filters",
  "search_landing__loading": "wj3UPW_search_landing__loading",
  "search_landing__results": "wj3UPW_search_landing__results",
});
